import React from 'react'
import { amtNumStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'

interface DetailProps {
  listAdjustment: any
}

export const ResidualValueAdjustmentDetailContent = (props: DetailProps) => {
  const { listAdjustment } = props

  return (
    <>
      <div className="content-wrap left">
        <div className="desc " style={{ color: 'grey' }}>
          {`Residual (%)`}
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listAdjustment?.ResidualPercent)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc " style={{ color: 'grey' }}>
          {`Residual Value`}
        </div>
        <div className="mdDesc text-noflow">
          {amtNumStr(listAdjustment?.ResidualValue)}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc " style={{ color: 'grey' }}>
          {`Description`}
        </div>
        <div className="mdDesc text-noflow">{listAdjustment?.Description}</div>
      </div>
      <div className="content-wrap left">
        <div className="desc " style={{ color: 'grey' }}>
          {`Reason`}
        </div>
        <div className="mdDesc text-noflow">{listAdjustment?.Reason}</div>
      </div>
    </>
  )
}
